import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  body {
    font-family: Montserrat, Arial, sans-serif;
    font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
    font-size: ${({ theme }) => theme.typography.fontSize.base};
    transition: background-color, 0.3s;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: Montserrat, Arial, sans-serif;
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};;
  }

  p, span {
    font-family: Montserrat, Arial, sans-serif;
  }

  a {
    color: ${({ theme }) => theme.colors.primary1};
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
    cursor: pointer;
  }
`;
